import arrowIcon from '@/assets/images/Icon.svg';
export const desktopArrowIcons = () => {
  return `
    <div id="arrow-icon-right-parent" class="arrow-icon-parent" id="arrow-icon-right-parent">
      <img src="${arrowIcon}" id="arrow-right-icon" alt="arrow-right-icon" class="arrow-icon" />
    </div>
    <div id="arrow-icon-left-parent" class="arrow-icon-parent" id="arrow-icon-left-parent">
      <img src="${arrowIcon}" id="arrow-left-icon" alt="arrow-left-icon" class="arrow-icon" />
    </div>
    <style>
      /* 共通の丸型背景付き矢印アイコン */
      #arrow-icon-right-parent,
      #arrow-icon-left-parent {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 48px;
        height: 48px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999;
      }

      /* 画面左右の配置 */
      #arrow-icon-right-parent { right: 24%; }
      #arrow-icon-left-parent  { left: 24%; }

      /* 矢印画像 */
      .arrow-icon {
        width: 24px;
        height: 24px;
      }

      /* 左矢印は反転 */
      #arrow-left-icon { transform: rotate(180deg); }
    </style>
  `;
}
